export const GET_FEATURED_PRODUCTS = 'featuredProducts/GET_FEATURED_PRODUCTS';
export const GET_FEATURED_PRODUCTS_SUCCESS =
  'featuredProducts/GET_FEATURED_PRODUCTS_SUCCESS';
export const GET_FEATURED_PRODUCTS_ERROR =
  'featuredProducts/GET_FEATURED_PRODUCTS_ERROR';
export const APPLY_PRODUCTS_FILTERS = 'featuredProducts/APPLY_PRODUCTS_FILTERS';
